import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Tooltip from 'components/ui/Tooltip';

import { Button } from 'react-bootstrap';
import showIcon from 'images/icons/invite/view.svg';
import editIcon from 'images/icons/invite/edit.svg';

import ExternalLink from 'components/Widgets/ExternalLink';
import routes from 'app/routes';

import Modal from '../Form/Modal';

export default function Actions({ row }) {
  const [show, setShow] = useState(false);

  return (
    <>
      <div>
        <a
          data-tip="View"
          href={routes.api.coaches.invoices.show(row.id)}
          rel="noreferrer"
          target="_blank"
        >
          <img src={showIcon} alt="Show Invoice" />
        </a>
        {row.attributes.status === 'created'
        && (
        <a
          data-tip="Edit"
          onClick={() => setShow(true)}
          className="ml5"
        >
          <img src={editIcon} alt="Edit Invoice" />
        </a>
        )}
      </div>
      <Tooltip clickable />
      <Modal
        row={row}
        show={show}
        onHide={() => setShow(false)}
      />
    </>
  );
}

Actions.propTypes = {
  row: PropTypes.object.isRequired,
};
